module.exports = {"tags":"Tags","category":"Category","outlet":"Outlet"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/dashboard.php
// module id = AmEg
// module chunks = 50